/* eslint-disable react-hooks/refs */
import {ActionIcon, ActionIconProps, Tooltip, TooltipProps} from "@mantine/core";
import {ReactNode, Ref} from "react";

export interface TooltipActionIconProps {
    ref?: Ref<HTMLButtonElement>
    tooltipProps?: Omit<TooltipProps, "children" | "label">
    actionIconProps?: Omit<ActionIconProps, "color" | "size">
    label: string
    children: ReactNode
    c?: string
    size?: string
    onClick?: (e?: any) => void
    loading?: boolean
    type?: "submit" | "reset" | "button"
}

export default function TooltipActionIcon(props: TooltipActionIconProps) {
    let tooltipProps = props.tooltipProps
    let actionIconProps = props.actionIconProps
    if (!tooltipProps) {
        tooltipProps = {}
    }
    if (!actionIconProps) {
        actionIconProps = {}
    }
    const label = props.label || "Tooltip not Provided"
    return <Tooltip label={label} {...tooltipProps}>
        <ActionIcon aria-label={label} color={props.c} size={props.size} {...actionIconProps} onClick={props.onClick} loading={props.loading} type={props.type || "button"} ref={props.ref}>
            {props.children}
        </ActionIcon>
    </Tooltip>
}